import React from 'react';
import { withTranslation } from 'react-i18next';
import { reactLoader, removeReactLoader, constructNestedKRPayload } from '../../../../utils/common.js';
import KrAlignDependance from './krAlignDependence';
import GoalServices from '../../../../services/goal.services';
import DeleteCommonModal from '../../../deleteCommonModal.component';
import NestedInlineComp from './NestedInline.component';
import { IntervalTexts, getIntervalOptions,
  WeekDaysOptionsText, isWeeklyInterval
} from '../../../../utils/metric';
import AddKrTag from "../../../../krTags/components/addkrTag.component";
import KrRelationshipWrapper from './krRelationshipWrapper.js';
import KrMilestonesSection from './KrMilestonesSection';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';


class KRStudioResults extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props
    this.state = {
      dayEn: false,
      dayType: this.props.item && this.props.item.weekly_update_day
        ? this.props.item.weekly_update_day
        : 5,
        tags:[],
      dsMetric: this.props.item && this.props.item.counting
        ? this.props.item.counting
        : 1,
      errors: {},
      exclude: this.props.item && this.props.item.progress_consider == 0,
      initial_data: this.props.item && this.props.item.initial_data
        ? this.props.item.initial_data
        : this.props.basicInlineData && this.props.basicInlineData.initial_data
          ? this.props.basicInlineData.initial_data
          : 0,
      intervalEn: false,
      intervalType: this.props.item && this.props.item.interval
        ? this.props.item.interval != 0 ? this.props.item.interval : 2
        : this.props.basicInlineData && this.props.basicInlineData.interval
          ? this.props.basicInlineData.interval != 0 ? this.props.basicInlineData.interval : 2
          : 2,
      krAlingSelected: this.props.item && this.props.item.kr_aligns !== undefined && this.props.item.kr_aligns.length > 0
        ? this.props.item.kr_aligns
        : [],
      krDependenciesSelected: this.props.item && this.props.item.kr_dependent !== undefined && this.props.item.kr_dependent.length > 0
        ? this.props.item.kr_dependent
        : [],
      krId: this.props.item && this.props.item.id ? this.props.item.id : null,
      lower_limit: this.props.item && this.props.item.upper_limit
        ? this.props.item.lower_limit
        : '',
      upper_limit: this.props.item && this.props.item.upper_limit
        ? this.props.item.upper_limit
        : '',
      MeasureEn: false,
      measureType: this.props.item && this.props.item.metric
        ? (this.props.item.metric == 4 || this.props.item.metric == 0) ? 1 : this.props.item.metric
        : this.props.basicInlineData && this.props.basicInlineData.metric
          ? this.props.basicInlineData.metric
          : 1,
      metricDD: false,
      progressEn: false,
      progressHelpPopUp: false,
      progType: this.props.item && this.props.item.progress_type
        ? this.props.item.progress_type
        : 1,
      target: this.props.item && this.props.item.target
        ? this.props.item.target
        : this.props.basicInlineData && this.props.basicInlineData.target
          ? this.props.basicInlineData.target
          : '',
      TargetHelpPopUp: false,
      startValueErr: t('Add Value'),
      targetValueErr: t('Add Value'),
      lowerLimitErr: t('Add Value'),
      upperLimitErr: t('Add Value'),
      krAssociation: this.props.krAssociation ? this.props.krAssociation : {},
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      milestones: this.props.item?.milestones ?? [],
    };
    this.saveKr = this.saveKr.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.targetClick = this.targetClick.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.setRightPaneValue = this.setRightPaneValue.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveKrAfterConfirmation = this.saveKrAfterConfirmation.bind(this);
    this.GoalServices = new GoalServices();
    this.updateTags = this.updateTags.bind(this);
    this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
    this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
    this.krMilestonesSectionRef = React.createRef();
  }

  handleChange(e) {
    const pattern = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
    const state = this.state;
    let name = e.target.name;
    let value = e.target.value;
    if (value === '' || pattern.test(value)) {
      state[name] = value;
      this.setState(state);
    }
    if (value === '' || pattern.test(value)) {
      this.setState({ errors: {} });
    }
  }

  componentWillUnmount() {
		this.props.metricRef(null)
	}

	componentDidMount() {
		this.props.metricRef(this)
	}

  componentDidUpdate(prevProp) {
    if (prevProp.krAssociation !== this.props.krAssociation && this.props.krAssociation !== undefined && this.props.krAssociation.constructor === Object && Object.keys(this.props.krAssociation).length > 0) {
      this.setState({ krAssociation: this.props.krAssociation});
    }
  }

  handleExcludeChange() {
    this.setState({ exclude: !this.state.exclude });
  }

  targetClick(e, id) {
    this.setState({ dsMetric: id, errors: {} });
  }

  saveDependentArr(dependentData) {
    this.setState({ krDependenciesSelected: dependentData })
  }

  saveAlignArr(alignData) {
    this.setState({ krAlingSelected: alignData })
  }

  setRightPaneValue(v) {
    this.props.closeKrRightPane(v);
  }

  exitDeleteModal() {
    this.setState({
      confirmPopup: false,
    });
  }

  saveKrAfterConfirmation() {
    this.setState({
      popupIsConfirmed: true,
      confirmPopup: false
    }, this.saveKr);
  }
  saveTag = (childData) =>{
    this.setState({tags:childData})
  }
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }

  getMilestonesPayload() {
    // Ensure milestones is an array before attempting to use array methods
    if (!Array.isArray(this.state.milestones)) {
      return '';
    }
    // milestones need to be an object with keys as index and values as milestone object (for api request)
    const milestones = this.state.milestones
      .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
      .reduce((acc, milestone, index) => ({
        ...acc,
        [index]: {
          id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
          date: milestone.date,
          label: milestone.label,
          target: milestone.target,
        }
      }), {});

    // if there are no milestones, return an empty string (for api request)
    return Object.keys(milestones).length > 0 ? milestones : '';
  }

  handleMilestonesChange(milestones) {
    this.setState({ milestones });
  }

  saveKr(callback = null) {
    const { t } = this.props
    const metricName = $("#metric-name-text").val();
    const metricNote = $("#metric-name-note").val() ? $("#metric-name-note").val() : '';
    const targetLowerVal = this.state.lower_limit;
    const targetUpperVal = this.state.upper_limit;
    const numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
    const alignments = [];
    const dependencies = [];
    const { actions } = this.props;
    const errors = {};

    // Check for milestones validation errors
    if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
      toastr.error(t('Milestone dates and values must be within start and target range'));
      return false;
    }

    if (this.props.krText === '' || metricName === '') {
      errors["metricName"] = true;
      this.props.showMetricNameErr();
    }

    if (typeof this.state.initial_data === 'undefined' || this.state.initial_data === '') {
      errors["showStartErr"] = true;
    } else if (this.state.initial_data !== '' && !numberWithComma.test(this.state.initial_data)) {
      errors["showStartErr"] = true;
      this.setState({
        startValueErr: t("Please enter numeric value.")
      });
    }

    if (this.state.dsMetric == 4) {
      if (targetLowerVal === '' || targetLowerVal === null) {
        errors["showTargetLowerErr"] = true;
      } else if (targetLowerVal !== '' && !numberWithComma.test(targetLowerVal)) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("Please enter numeric value.")
        });
      }

      if (targetUpperVal === '' || targetUpperVal === null) {
        errors["showTargetUpperErr"] = true;
      } else if (targetUpperVal !== '' && !numberWithComma.test(targetUpperVal)) {
        errors["showTargetUpperErr"] = true;
        this.setState({
          upperLimitErr: t("Please enter numeric value.")
        });
      }

      if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
        errors["showTargetLowerErr"] = true;
        this.setState({
          lowerLimitErr: t("Lower limit is greater than Upper limit.")
        });
      }
    } else {
      if (this.state.target === '' || this.state.target === null) {
        errors["showTargetErr"] = true;
      } else if (this.state.target !== '' && !numberWithComma.test(this.state.target)) {
        errors["showTargetErr"] = true;
        this.setState({
          targetValueErr: t("Please enter numeric value.")
        });
      }

      if (this.state.dsMetric == 1 && parseFloat(this.state.initial_data) > parseFloat(this.state.target)) {
        errors["showStartErr"] = true;
        this.setState({
          startValueErr: t("Starting value should be less than target.")
        });
      } else if (this.state.dsMetric == 2 && parseFloat(this.state.initial_data) < parseFloat(this.state.target)) {
        errors["showStartErr"] = true;
        this.setState({
          startValueErr: t("Starting value should be greater than target.")
        });
      }
    }

    if (this.props.lastType != this.props.krType
      && this.props.lastType !== 'person' // no alert when going from person to krstudio, ww-11568
      && this.props.addEditFlag
      && !this.state.popupIsConfirmed) {
      this.setState({ confirmPopup: true })
      return;
    }

    if (Object.keys(this.state.krAlingSelected).length) {
      this.state.krAlingSelected.map(kr => { alignments.push(kr.id); });
    }
    if (Object.keys(this.state.krDependenciesSelected).length) {
      this.state.krDependenciesSelected.map(kr => { dependencies.push(kr.id); });
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids=this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds,...tagids]
      const params = {
        'source': '8',
        'ext_app_id': '15',
        'name': metricName,
        'description': metricNote,
        'metric': this.state.measureType,
        'owner': this.props.item.owner,
        'initial_data': this.state.initial_data,
        'counting': this.state.dsMetric,
        'interval': this.state.intervalType,
        'krAligns': alignments,
        'dependentKr': dependencies,
        'permission': this.props.goalDetails.permission,
        'progress_consider': this.state.exclude ? 0 : 1,
        'real_owner': this.props.showRealOwner ? this.props.realOwner.id : this.props.item.owner,
        "krTagIds" : finalTagsIds
      };
      params["nested_krs"] = constructNestedKRPayload(this.props);
      // Include milestones data if available
      params.milestones = this.getMilestonesPayload();
      if (this.props.item && this.props.item.id) {
        params.id = this.props.item.id;
      }
      if (this.state.dsMetric == 4) {
        params.lower_limit = this.state.lower_limit;
        params.upper_limit = this.state.upper_limit;
        params.progress_type = '1';
      } else {
        params.target = this.state.target;
        params.progress_type = this.state.progType;
      }
      if (isWeeklyInterval(this.state.intervalType)) {
        params.weekly_update_day = this.state.dayType;
      }
      if (this.state.krAssociation.constructor === Object && Object.keys(this.state.krAssociation).length) {
        params.instance_url = this.props.krAssociation.url;
        params.kr_association = this.props.krAssociation;
      }
      //console.log('params: %o', params);
      if(this.props.isChildKr && this.props.fromParentKr){
        params.ownerName = this.state.data_provider.id ? this.state.data_provider.name : this.props.realOwner.name;
        params.duration = this.props.childKrDuration;
        if(this.props.item.parent){
          // params.start_date = this.props.childKrDuration.start ;
          // params.end_date = this.props.childKrDuration.end;
          params.parent = this.props.item.parent;
        }
        //params.duration = this.state.data_provider.name;
        this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
      } else {
        if(this.props.item.parent){
          params.start_date = this.props.childKrDuration.start ;
          params.end_date = this.props.childKrDuration.end;
          params.parent = this.props.item.parent;
        }
        reactLoader(true);
        if (params.kr_association) {
          this.GoalServices.addEditKr({ goalId: this.props.goalDetails.id, metric: params }).then(
            response => {
              if (typeof actions !== 'undefined' && response.data) {
                const result = response.data.data;
                let krWeightage = null;
                if (result.krWeightage) {
                  krWeightage = result.krWeightage;
                  delete result['krWeightage'];
                }
                result = {
                  clusterItems: this.props.clusterData,
                  clusterCount: this.props.clusterData.length,
                  ...result
                };
                if(result.parent){
                  actions.addUpdateNestedKr(result)
                } else{
                  if (this.state.krId) {
                    actions.editNewKr(this.state.krId, result);
                  } else {
                    actions.addNewKr(result);
                  }
                }
                if (krWeightage) {
                  this.props.MetricChangeWeight(krWeightage);
                }
              }
              if(typeof response.data.err !== 'undefined' && response.data.err){
                alert(response.data.err);
              }
              removeReactLoader();
              if (callback) {
                callback(result);
              } else {
                this.setRightPaneValue(true);
              }
            }
          ).catch((error) => {
            alert(t('Unable to save the key result, please try again later')+'!');
          });
        } else {
          alert(`${t('Association not found.')} ${t('Please try again.')}`);
        }
      }
    }
  }

  render() {
    const { t } = this.props;
    const dsMetric = { 1: t('Should increase to'), 2: t('Should decrease to'), 3: t('Should be equal to'), 4: t('Should fall within a range') }; // sms!
    const dsProg = {
      1: t('Last Entered Value'),
      2: t('Total of all entered values'),
      3: t('Average of all entered values')
    };
    const basicMeasure = {
      1: t('Count as number'),
      2: t('Count as currency'),
      3: t('Count as percentage')
    };
    const basicInterval = IntervalTexts;
    const basicIntervalArr = getIntervalOptions('default', this.props.addOkrData.isEnabledBiweeklyKR, false, false);
    const basicDays = WeekDaysOptionsText();
    const errors = this.state.errors;
    const hasErrors = Object.keys(errors).length;

    return (
      <div className="basickrModal">
        <form onSubmit={this.saveKr}>
          <div>
            {/* Row: Select data source */}
            {typeof this.state.krAssociation.id !== 'undefined' && (
            <div className="krsDataSourceWrapper">
              <div className="krsDataSourceLabel">
                <span>{t('Selected data source')}:</span>
              </div>
              <div className="krsDataSourceList flex-row-full">
                <div className="krsDataSourceItem flex-item" id={`dsid-${this.state.krAssociation.id}`}>
                  {this.state.krAssociation.name}
                </div>
                <div className="krsDataSourceLink flex-item" onClick={this.props.resetKrAssociation}>
                  {t('Switch data source')}
                </div>
              </div>
            </div>
            )}

            {/* Row: Start and target values */}
            <div className="basickrstarttargetHead">
              <div className="metrictargettext inLineBlk">
                {t('Starting from')}<span className="text-style-1">*</span>
              </div>
              <div className="krs-target-value-text inLineBlk targetHelp">
                {" "}
                {t('Result value')}
                <div className="metricTargetHelptext"
                  onMouseEnter={event => {
                    this.setState({ TargetHelpPopUp: true });
                  }}
                  onMouseLeave={event => {
                    this.setState({ TargetHelpPopUp: false });
                  }}
                />
                {this.state.TargetHelpPopUp && (
                  <div className="basic-popup">
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should increase to ')}</strong>
                        {t('example') + ': '}{t('Starting from 0 MQLs moving to 10 MQLs')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should decrease to ')}</strong>
                        {t('example') + ': '}{t('Starting from 100 bugs moving to 10 bugs')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should be equal to ')}</strong>
                        {t('example') + ': '}{t('When you have an exact number to hit, like hiring exactly 10 developers - not less, not more')}
                      </span>
                    </div>
                    <div className="targetHelp">
                      <span className="dot inLineBlk" />
                      <span className="targetHelpDec inLineBlk">
                        <strong>{t('Should fall within a range ')}</strong>
                        {t('example') + ': '}{t('Starting from $0 aiming to move towards a range of $10-$15')}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {this.state.dsMetric != 4 && (
                <div className="metric-target-text inLineBlk">
                  {t('Target value')}<span className="text-style-1">*</span>
                </div>
              )}
              {this.state.dsMetric == 4 && (
                <div className="metric-lower-text inLineBlk">
                  {t('Target lower limit')} <span className="text-style-1">*</span>
                </div>
              )}

              {this.state.dsMetric == 4 && (
                <div className="metric-uppert-text inLineBlk">
                  {t('Target upper limit')}<span className="text-style-1">*</span>
                </div>
              )}
            </div>
            <div className="basickrstarttargets">
              <div className={"verticalTop inLineBlk" +
                (typeof errors["showStartErr"] !== "undefined"
                  ? " errorBorder "
                  : "")
              }>
                <input className="metric-start-value"
                  type="text"
                  autoComplete="off"
                  name="initial_data"
                  ref="initial_data"
                  value={this.state.initial_data}
                  onChange={this.handleChange}
                />
              </div>
              <div className={"verticalTop metricTargetValue inLineBlk "}
                onClick={event => {
                  this.setState({ metricDD: !this.state.metricDD });
                }}>
                <div className={"dsMetricSelImg_" + this.state.dsMetric} />
                <div className="inLineBlk marginleft7pt5">{dsMetric[this.state.dsMetric]}</div>
                <div className="arrowDown" />
                {this.state.metricDD && (
                  <div id="myAlign" data-testid="myAlign" className="dropdown-alignment ">
                    <div className={"MeasureOption dsMetricSelImg "}
                      onClick={event => {
                        this.targetClick(event, 1);
                      }}>
                      <div className="dsMetricSelImg_1" />
                      <div className="rangeTarget inLineBlk">{dsMetric[1]}</div>
                    </div>
                    <div className={"MeasureOption dsMetricSelImg "}
                      onClick={event => {
                        this.targetClick(event, 2);
                      }}>
                      <div className="dsMetricSelImg_2" />
                      <div className="rangeTarget inLineBlk">{dsMetric[2]}</div>
                    </div>
                    <div className={"MeasureOption dsMetricSelImg"}
                      onClick={event => {
                        this.targetClick(event, 3);
                      }}>
                      <div className="dsMetricSelImg_3" />
                      <div className="rangeTarget inLineBlk">{dsMetric[3]}</div>
                    </div>
                    <div
                      className={"MeasureOption dsMetricSelImg "}
                      onClick={event => {
                        this.targetClick(event, 4);
                      }}>
                      <div className="dsMetricSelImg_4" />
                      <div className="rangeTarget inLineBlk">{dsMetric[4]}</div>
                    </div>
                  </div>
                )}
              </div>
              {this.state.dsMetric != 4 && (
                <div className={"verticalTop inLineBlk" +
                  (typeof errors["showTargetErr"] !== "undefined"
                    ? " errorBorder "
                    : "")
                }>
                  <input className="metric-end-value"
                    type="text"
                    data-testid="metric-end-value"
                    autoComplete="off"
                    name="target"
                    ref="target"
                    value={this.state.target}
                    onChange={this.handleChange}
                  />
                </div>
              )}

              {this.state.dsMetric == 4 && (
                <div className={"verticalTop inLineBlk" +
                  (typeof errors["showTargetLowerErr"] !== "undefined"
                    ? " errorBorder "
                    : "")
                }>
                  <input className="metric-lower-value"
                  data-testid="metric-lower-value"
                    type="text"
                    autoComplete="off"
                    name="lower_limit"
                    ref="lower_limit"
                    value={this.state.lower_limit}
                    onChange={this.handleChange}
                  />
                </div>
              )}

              {this.state.dsMetric == 4 && (
                <div className="verticalTop inLineBlk">
                  <input className={"metric-upper-value" +
                      (typeof errors["showTargetUpperErr"] !== "undefined"
                        ? " errorBorder "
                        : "")
                    }
                    type="text"
                    autoComplete="off"
                    name="upper_limit"
                    ref="upper_limit"
                    value={this.state.upper_limit}
                    onChange={this.handleChange}
                  />
                </div>
              )}
            </div>
            <div className=" basickrstarttargets">
              <div className="verticalTop inLineBlk startErr">
                {hasErrors && typeof errors["showStartErr"] !== "undefined" ? (
                  <div className="krstarttargetError">
                    <div className="outline-error_outline-14px-red" />
                    <div className="start-target">
                      {this.state.startValueErr}
                    </div>
                  </div>
                ) : (
                  <div>&nbsp;</div>
                )}
              </div>
              <div className="verticalTop inLineBlk">
                {hasErrors && typeof errors["showTargetErr"] !== "undefined" ? (
                  <div className="krstarttargetError">
                    <div className="outline-error_outline-14px-red" />
                    <div className="Enter-target">
                      {this.state.targetValueErr}
                    </div>
                  </div>
                ) : (
                  <div>&nbsp;</div>
                )}
              </div>
              <div className="verticalTop inLineBlk lowerLimit">
                {hasErrors && typeof errors["showTargetLowerErr"] !== "undefined" ? (
                  <div className="krstarttargetError">
                    <div className="outline-error_outline-14px-red" />
                    <div className="Enter-target">
                      {this.state.lowerLimitErr}
                    </div>
                  </div>
                ) : (
                  <div>&nbsp;</div>
                )}
              </div>
              <div className="verticalTop inLineBlk upperLimit">
                {hasErrors && typeof errors["showTargetUpperErr"] !== "undefined" ? (
                  <div className="krstarttargetError">
                    <div className="outline-error_outline-14px-red" />
                    <div className="Enter-target">
                      {this.state.upperLimitErr}
                    </div>
                  </div>
                ) : (
                  <div>&nbsp;</div>
                )}
              </div>
            </div>

            {/* Row: Measurement unit and agregation */}
            <div className="flex-row-left">
              <div className="flex-item">
                <div className="CalculateOver">
                  <span>{t('Unit of measurement')}</span>
                </div>
                <div className="basickrstarttarget metricmeasureArea">
                  <div className="krs-option inLineBlk metricmeasureDiv"
                    onClick={event => {
                      this.setState({ MeasureEn: !this.state.MeasureEn });
                    }}>
                    <div className="person-measure-text-arrow truncate">
                      {basicMeasure[this.state.measureType]}
                    </div>
                    <div className="arrowDown " />

                    {this.state.MeasureEn && (
                    <div id="myAlign" data-testid="myAlign" className="dropdown-alignment">
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ measureType: 1, MeasureEn: false });
                        }}>
                        {basicMeasure[1]}
                      </div>
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ measureType: 2, MeasureEn: false });
                        }}>
                        {basicMeasure[2]}
                      </div>
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ measureType: 3, MeasureEn: false });
                        }}>
                        {basicMeasure[3]}
                      </div>
                    </div>
                    )}
                  </div>
                </div>
              </div>

              {this.state.dsMetric != 4 && (
              <div className="flex-item">
                <div className="CalculateOverAll">
                  <span>
                    {t('Calculate overall progress as')}
                    <div className="metricTargetHelptext progressCal"
                      onMouseEnter={event => {
                        this.setState({ progressHelpPopUp: true });
                      }}
                      onMouseLeave={event => {
                        this.setState({ progressHelpPopUp: false });
                      }}
                    />
                    {this.state.progressHelpPopUp && (
                    <div className="basic-popup">
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Last entered value')}: </strong>{t(`If a user entered "4" for the last update, the overall progress would also show "4".`)}
                        </span>
                      </div>
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Total of all entered values')}: </strong>{t(`If a user entered "2", "3" and "4" for all of their updates, the overall progress would show "9".`)}
                        </span>
                      </div>
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Average of all entered values')}: </strong>{t(`If a user entered "2", "3" and "4" for all of their updates, the overall progress would show "3".`)}
                        </span>
                      </div>
                    </div>
                    )}
                  </span>
                </div>
                <div className="CalculateOverDropDown" data-testid="CalculateOverDropDown">
                  <div className="inLineBlk calculateProgress"
                    onClick={event => {
                      this.setState({ progressEn: !this.state.progressEn });
                    }}>
                    <div className="cal-text-arrow truncate">
                      {dsProg[this.state.progType]}
                    </div>
                    <div className="arrowDown " />

                  {this.state.progressEn && (
                    <div id="myAlign" data-testid="myAlign" className="dropdown-alignment">
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ progType: 1, showProgType: false });
                        }}>
                        {dsProg[1]}
                      </div>
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ progType: 2, showProgType: false });
                        }}>
                        {dsProg[2]}
                      </div>
                      <div className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                          this.setState({ progType: 3, showProgType: false });
                        }}>
                        {dsProg[3]}
                      </div>
                    </div>
                  )}
                  </div>
                </div>
              </div>
              )}
            </div>

            {/* Row: Update cadence */}
            <div className="Person-responsible-f">{t('Update cadence')}</div>
            <div className="krs-option krTimeRange inLineBlk"
            data-testid="krTimeRange"
              onClick={event => {
                $('.krRightPaneContent').parent().animate({ scrollTop: 500 });
                this.setState({ intervalEn: !this.state.intervalEn });
              }}>
              <div className="person-interval-text-arrow truncate">
                {basicInterval[this.state.intervalType]}
              </div>
              <div className="arrowDown " />

              {this.state.intervalEn && (
                <div id="myAlign" data-testid="myAlign" className="dropdown-alignment krStudio">
                  {basicIntervalArr.map((item, index) => (
                      <div
                        key={index}
                        className="MeasureOption" data-testid="MeasureOption"
                        onClick={event => {
                        this.setState({ intervalType: item["value"], intervalEn: false });
                        }}
                      >
                        {item["name"]}
                      </div>
                  ))}
                </div>
              )}
            </div>
            {(isWeeklyInterval(this.state.intervalType)) && (
              <div className="verticalTop onMetric inLineBlk"> {t('on')} </div>
            )}
            {(isWeeklyInterval(this.state.intervalType)) && (
              <div className="krs-option metricTimeRange inLineBlk"
                onClick={event => {
                  $('.krRightPaneContent').parent().animate({ scrollTop: 500 });
                  this.setState({ dayEn: !this.state.dayEn });
                }}>
                <div className="person-day-text-arrow truncate">
                  {basicDays[this.state.dayType]}
                </div>
                <div className="arrowDown " />
                {this.state.dayEn && (
                  <div id="myAlign" data-testid="myAlign" className="dropdown-alignment">
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 1, dayEn: false });
                      }}>
                      {basicDays[1]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 2, dayEn: false });
                      }}>
                      {basicDays[2]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 3, dayEn: false });
                      }}>
                      {basicDays[3]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 4, dayEn: false });
                      }}>
                      {basicDays[4]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 5, dayEn: false });
                      }}>
                      {basicDays[5]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 6, dayEn: false });
                      }}>
                      {basicDays[6]}
                    </div>
                    <div className="MeasureOption" data-testid="MeasureOption"
                      onClick={event => {
                        this.setState({ dayType: 7, dayEn: false });
                      }}>
                      {basicDays[7]}
                    </div>
                  </div>
                )}
              </div>
            )}

            {(!this.props.isChildKr && (this.state.dsMetric != 4 ||  this.props.addOkrData.display_nested_kr)) && <div className="krBreak" aria-hidden="true" />}
            {!this.props.isChildKr && (
              <KrMilestonesSection ref={this.krMilestonesSectionRef} {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
            )}
            <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveKr}/>
            <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
            <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
            nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
            />
            {

              (this.props.addOkrData.display_nested_kr &&
              !this.props.isChildKr &&
              Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
              <NestedInlineComp
              {...this.props}
              actions = {this.props.actions}
              nested_krs = {this.props.nested_krs}
              updateNestedKrs = {this.props.updateNestedKrs}
              />
            }
            {
              !this.props.isChildKr &&
              <KrAlignDependance {...this.props}
                saveDependentArr={this.saveDependentArr}
                saveAlignArr={this.saveAlignArr}
                krAlingArr={this.props.item.kr_aligns}
                krDependenciesArr={this.props.item.kr_dependent} />
            }
     
            {/* Row: Row 'Exclude from progress' checkbox */}
            {
              !this.props.isChildKr &&
              <div className="excludeProgressArea">
                <div className="excludeProgressSec">
                  <input className="excludeProgressInput"
                    id="excludePro"
                    name=""
                    type="checkbox"
                    ref={node => (this.dsExcludeProg = node)}
                    defaultChecked={this.state.exclude ? true : false}
                    onChange={this.handleExcludeChange}
                  />
                  <label htmlFor="excludePro" />
                  <span className="excludeProgressText">{t('Exclude this key result from objective progress calculation')}</span>
                </div>
              </div>
            }
            {this.state.confirmPopup &&
              <DeleteCommonModal
                exitDeleteModal={this.exitDeleteModal}
                deleteItems={this.saveKrAfterConfirmation}
                id=""
                title={t("Save Key Result with New Data Type")}
                deleteContentOne=""
                deleteContentSecondParam=""
                deletefirstTitle=""
                deleteContentSecond={t("Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.")}
                buttonText={t('Save')}
              />}
          </div>
        </form>
      </div>
    );
  }
}

export default withTranslation()(KRStudioResults)
